import { render, staticRenderFns } from "./EpicEditor.vue?vue&type=template&id=5c1efb95&scoped=true&"
import script from "./EpicEditor.vue?vue&type=script&lang=ts&"
export * from "./EpicEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EpicEditor.vue?vue&type=style&index=0&id=5c1efb95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1efb95",
  null
  
)

export default component.exports